export const accounts = [
  {
    email: "test@healthysure.in",
    password: "Root@1234",
    name: "Healthysure",
  }
]
